require('./catalog.component.scss');

class CatalogController {
  constructor(CatalogNodeDragService, $element) {
    this.drag = CatalogNodeDragService;
  }
}

export const CatalogComponent = {
  template: require('./catalog.component.html'),
  bindings: {
    model: '<',
    filter: '<',
    filters: '<',
  },
  controller: CatalogController,
   transclude : true
};



// WEBPACK FOOTER //
// ./src/filter/catalog/catalog.component.js